export const GET_HOLTER_LIST_DATA = 'GET_HOLTER_LIST_DATA'
export const GET_HOLTER_DATA = 'GET_HOLTER_DATA'
export const GET_HOLTER_DOCUMENT = 'GET_HOLTER_DOCUMENT'
export const HOLTER_DOC_LOADING = 'HOLTER_DOC_LOADING'
export const SET_ECG_LOADING = 'SET_ECG_LOADING'
export const RESET_HOLTER_DOCUMENT = 'RESET_HOLTER_DOCUMENT'
export const CLEAR_HOLTER = 'CLEAR_HOLTER'
